<template>
  <ngc-input-dropdown
    v-value="normalizedValue"
    multiselect
    wrap-chips
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    :options.prop="dropdownOptions"
    @change="handleChange"
  />
</template>

<script>
export default {
  name: 'EnvSelect',
  directives: {
    // Mirror the platform's `v-value` directive: set the element's value
    // property on insert and on every update so the Gator dropdown reliably
    // reflects the selected chips.
    value: {
      inserted (el, binding) {
        el.value = binding.value
      },
      update (el, binding) {
        el.value = binding.value
      }
    }
  },
  props: {
    items: {
      type: Array,
      default: () => [],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    value: {
      type: [String, Number, Array],
      default: '',
      required: false
    },
    placeholder: {
      type: String,
      default: 'Select environments this user can access',
      required: false
    },
    label: {
      type: String,
      default: '',
      required: false
    }
  },
  computed: {
    dropdownOptions () {
      return this.items.map(item => ({ label: item, value: item }))
    },
    normalizedValue () {
      if (Array.isArray(this.value)) {
        return [...this.value]
      }
      return this.value ? [this.value] : []
    }
  },
  methods: {
    handleChange (event) {
      this.$emit('input', event.detail.value || [])
    }
  }
}
</script>

<style scoped>
</style>
